module.exports = __webpack_public_path__ + "static/media/Scruffy-Coat1024.d9919aa4.jpg";